import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Subscription } from 'rxjs';
import { MktEnvironmentService } from 'src/app/core/services/mkt-environment.service';
import { MktContentStorageService } from 'src/app/core/services/mkt-content-storage.service';
import { ScrollFocusService } from 'src/app/common/services/scroll-focus.service';
import { MktCommonModule } from 'src/app/common/mkt-common.module';

@Component({
  selector: 'app-benefit-section',
  templateUrl: './benefit-section.component.html',
  styleUrls: ['./benefit-section.component.scss'],
  imports:[MktCommonModule],
  standalone: true
})
export class BenefitSectionComponent implements OnInit, OnDestroy {

  benefitContent: any = null;
  mobileOnly = false;
  imageBasePath: string = '';
  routeSub: Subscription = new Subscription();

  constructor(
    private _mktContentStorageService: MktContentStorageService,
    private mktEnvironmentService: MktEnvironmentService,
    private route: ActivatedRoute,
    private scrollFocusService: ScrollFocusService) {
    this.imageBasePath = this.mktEnvironmentService.getEnvironmentVar('cardsmkrHostName');
  }

  ngOnInit(): void {
    this.mobileOnly = window.innerWidth < 678;
    this.getBenefitContent();
  }

  ngOnDestroy() {
    this.routeSub.unsubscribe();
  }

  @HostListener('window:resize', ['$event'])
  resize(event) {
    const width = event.target.innerWidth || window.innerWidth;
    this.mobileOnly = width < 678;
  }

  private getBenefitContent() {
    this.routeSub = combineLatest([
      this.route.params,
    ]).subscribe(params => {
      const cardName = params[0]['cardName'].replace(/\./g, '');
      // Try to get card pricing details
      const mainPdpContentObject = this._mktContentStorageService.get('Product_Detail_Pages', 'copy', cardName, undefined);
      if (!mainPdpContentObject) {
        return;
      }
      const benefitContent = JSON.parse(mainPdpContentObject['benefitSection']);
      if (!benefitContent || !benefitContent.benefitActive) { return; }
      this.benefitContent = {
        ...benefitContent,
        benefits: benefitContent.benefits.map((benefit) => { benefit.iconPath = `${this.imageBasePath}${benefit.iconPath}`; return benefit; }
        )
      };
    });
  }

  updateCSS() {
    alert("test");
  }

  scroll(sectionId: string) {
    this.scrollFocusService.scrollFocus({},sectionId,'pdp');
  }
}





